/**
 * BREAKING NEWS
 */


export class BreakingNews {
    constructor(dynamics, el) {
        this.dynamics = dynamics;
        this.el = el;

        this.init();
    }

    init() {
        for (let i = 0; i < this.dynamics.length; i++){
            let slides = this.dynamics[i].getElementsByClassName(this.el);
            if (!slides.length
                || slides.length === 1) {
                continue;
            }

            this.bindEvents(slides);
        }
    }

    bindEvents(slides) {
        let addActive = (slide) => {
            slide.classList.add('active')
        };

        let removeActive = (slide) => {
            slide.classList.remove('active')
        };

        addActive(slides[0]);

        window.setInterval(() => {
            for (let i = 0; i < slides.length; i++){
                if (!slides[i].classList.contains('active')) {
                    continue;
                }

                let activeSlide = i + 1;
                if (activeSlide === slides.length) {
                    activeSlide = 0;
                }

                removeActive(slides[i]);
                addActive(slides[activeSlide]);

                break;
            }
        }, 5000);
    }
}
